module.exports = __webpack_public_path__ + "img/14ne.814252c6.svg";